import { Box, BoxProps, Image } from '@chakra-ui/react';
import TableSectionWithNav from '../../sections/TableSectionWithNav/TableSectionWithNav';

interface Props extends BoxProps {}

export const ImplementationTable = ({ ...props }: Props) => {
    const mainCategories = {
        OPIEKUN_WDROZENIA: 'Opiekun wdrożenia',
        SZKOLENIA: 'Szkolenia',
        KONFIGURACJA: 'Konfiguracja',
        IMPORT_DANYCH: 'Import danych',
        DOSTOSOWANIE_SZABLONU: 'Dostosowanie szablonu sklepu',
    };

    const headerValues = [
        {
            title: 'Pakiet, dzięki któremu możesz ekspresowo wystartować ze sprzedażą internetową',
            price: '1 zł *',
            crossedPrice: '1199 zł',
            priceTop: 'już od',
            priceColor: '#DD1C4A',
            priceInfo: '* w wybranym planie abonamentowym',
            linkName: 'Sprawdź abonamenty',
            href: 'https://www.idosell.com/pl/abonamenty/',
            type: 'BASIC',
        },
        {
            title: 'Pakiet, dzięki któremu rozpoczniesz sprzedaż w profesjonalnym stylu',
            price: '1 zł *',
            crossedPrice: '3999 zł',
            priceTop: 'już od',
            priceColor: '#DD1C4A',
            priceInfo: '* w wybranym planie abonamentowym',
            linkName: 'Sprawdź abonamenty',
            href: 'https://www.idosell.com/pl/abonamenty/',
            type: 'GO',
        },
        {
            title: 'Pakiet, dzięki któremu sprawnie przeniesiesz sklep z innej platformy lub dostosujesz wygląd naszego szablonu do swoich potrzeb',
            price: '1 zł *',
            crossedPrice: '14999 zł',
            priceTop: 'już od',
            priceColor: '#DD1C4A',
            priceInfo: '* w wybranym planie abonamentowym',
            linkName: 'Sprawdź abonamenty',
            href: 'https://www.idosell.com/pl/abonamenty/',
            type: 'GO_PLUS',
        },
        {
            title: 'Pakiet, dzięki któremu skorzystasz w pełni z zasobów, jakie daje IdoSell, poprzez rozwiązania szyte na miarę Twojego biznesu',
            price: '190 zł/h',
            priceInfo: '* w wybranym planie abonamentowym',
            linkName: 'Sprawdź abonamenty',
            href: 'https://www.idosell.com/pl/abonamenty/',
            type: 'INDIVIDUAL',
        }
    ]

    const valuesName = {
        BASIC: 'Basic',
        GO: 'Go',
        GO_PLUS: 'Go+',
        INDIVIDUAL: 'Wdrożenie indywidualne',
    };

    const valuesNameMobile = {
        BASIC: 'Basic',
        GO: 'GO',
        GO_PLUS: 'GO+',
        INDIVIDUAL: 'Indywidualny',
    };

    const scaleImage = {
        NULL: (
            <Image
                src="https://www.idosell.com/panel/file-gate.php?id=478108&ext=.svg"
                alt="Brak"
            />
        ),
        ONE_THIRD: (
            <Image
                src="https://www.idosell.com/panel/file-gate.php?id=478106&ext=.svg"
                alt="W małym stopniu"
            />
        ),
        TWO_THIRD: (
            <Image
                src="https://www.idosell.com/panel/file-gate.php?id=478105&ext=.svg"
                alt="W dużym stopniu"
            />
        ),
        FULL: (
            <Image
                src="https://www.idosell.com/panel/file-gate.php?id=478104&ext=.svg"
                alt="Pełna skala"
            />
        ),
    };

    const tableSection = [
        {
            category: mainCategories.OPIEKUN_WDROZENIA,
            name: '',
            values: {
                BASIC: scaleImage.FULL,
                GO: scaleImage.FULL,
                GO_PLUS: scaleImage.FULL,
                INDIVIDUAL: scaleImage.FULL,
            },
            details: [
                {
                    name: '<b>Konfiguracja</b> Twojego sklepu zgodna z zakresem wybranego pakietu',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Opieka nad całością procesu</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
            ],
        },
        {
            category: mainCategories.SZKOLENIA,
            subtitle: 'wprowadzające do IdoSell',
            name: '',
            values: {
                BASIC: scaleImage.TWO_THIRD,
                GO: scaleImage.TWO_THIRD,
                GO_PLUS: scaleImage.TWO_THIRD,
                INDIVIDUAL: scaleImage.FULL,
            },
            details: [
                {
                    name: 'Dostęp do nagrań szkoleniowych <b>z instrukcją obsługi panelu oraz kluczowych integracji</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Sesja Q&A</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Opieka</b> na każdym etapie procesu wdrożeniowego',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Dodatkowe <b>dwie dedykowane sesje szkoleniowe</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: false,
                        INDIVIDUAL: true,
                    },
                },
            ],
        },
        {
            category: mainCategories.KONFIGURACJA,
            subtitle: 'kluczowych funkcjonalności',
            name: '',
            values: {
                BASIC: scaleImage.TWO_THIRD,
                GO: scaleImage.TWO_THIRD,
                GO_PLUS: scaleImage.FULL,
                INDIVIDUAL: scaleImage.FULL,
            },
            details: [
                {
                    name: 'Ustawienie <b>wybranego, darmowego  szablonu</b> standardowego i wgranie przesłanych <b>banerów oraz logo</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Uzupełnienie danych w <b>dokumentach sprzedażowych</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Konfiguracja <b>płatności</b> (na rynek polski i wybrany rynek zagraniczny)',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Konfiguracja <b>magazynów</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Przygotowanie Twojego sklepu do <b>integracji z Allegro</b> oraz innego <b>wybranego markeplace</b> na rynek polski',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Pomoc w połączeniu sklepu z <b>porównywarkami cenowymi</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Wsparcie w połączeniu z <b>Facebookiem i Instagramem</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Uzupełnienie domyślnych <b>metatagów pod SEO</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Wsparcie w konfiguracji <b>sprzedaży B2B</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Instalacja i konfiguracja <b>aplikacji pomocniczych IdoSell: Bridge, POS, Printer, Scanner</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Konfiguracja i przepięcie <b>domeny Twojego sklepu</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Większa <b>ilość magazynów</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Konfiguracja <b>oferty dostawcy</b> spoza platformy IdoSell <b>bez dodatkowych opłat</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Przygotowanie panelu do <b>integracji z 5 marketplaces</b> sprzedającymi na rynek polski',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Konfiguracja <b>programu lojalnościowego</b> dla Twoich klientów',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Dostosowanie wszelkich możliwości konfiguracyjnych naszego panelu specjalnie do Twoich potrzeb</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: false,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Responsywny szablon standard</b> (RWD)',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Gwarancja na szablon</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
            ],
        },
        {
            category: mainCategories.IMPORT_DANYCH,
            subtitle: 'na start sprzedaży',
            name: '',
            values: {
                BASIC: scaleImage.ONE_THIRD,
                GO: scaleImage.ONE_THIRD,
                GO_PLUS: scaleImage.TWO_THIRD,
                INDIVIDUAL: scaleImage.FULL,
            },
            details: [
                {
                    name: 'Import <b>oferty towarów</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Import <b>bazy klientów</b>',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Import <b>przekierowań adresów towarów</b> (pod kątem SEO)',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Import <b>opinii o towarach</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Import <b>wpisów blogowych</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: false,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Import <b>opisów kategorii lub producentów</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: false,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Migracja z takich platform jak:</b> WooCommerce, PrestaShop, Shoper, Shopify, Magento, RedCart, BaseLinker, shopGold, Sky-Shop, SOTE, EBEXO, Comarch e-Sklep, TakeDrop, GOshop, WAPRO, Atom Store, KQS.store, Sellasist, OpenCart, Shopware',
                    values: {
                        BASIC: true,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Migracja z <b>każdej platformy</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: false,
                        INDIVIDUAL: true,
                    },
                },
            ],
        },
        {
            category: mainCategories.DOSTOSOWANIE_SZABLONU,
            subtitle: 'obejmuje prace graficzne, UI/UX, deweloperskie',
            name: '',
            values: {
                BASIC: scaleImage.NULL,
                GO: scaleImage.ONE_THIRD,
                GO_PLUS: scaleImage.TWO_THIRD,
                INDIVIDUAL: scaleImage.FULL,
            },
            details: [
                {
                    name: 'Dzień projektowy z projektantem graficznym',
                    values: {
                        BASIC: false,
                        GO: true,
                        GO_PLUS: false,
                        INDIVIDUAL: false,
                    },
                },
                {
                    name: 'Indywidualny zakres materiałów graficznych na start sprzedaży (np. 2-3 banery, projekt prostego logotypu)',
                    values: {
                        BASIC: false,
                        GO: true,
                        GO_PLUS: false,
                        INDIVIDUAL: false,
                    },
                },
                {
                    name: 'Konsultacja z projektantem UI/UX',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Dostosowanie indywidualnie dobranej kolorystyki i czcionek',
                    values: {
                        BASIC: false,
                        GO: true,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Indywidualne doradztwo</b> pod kątem UI/UX, by skłonić użytkowników do <b>pozostania dłużej w Twoim sklepie</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Indywidualnie dostosowany</b> pod desktop i mobile, responsywny projekt  (RWD)',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: false,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: 'Realizacja przez naszych <b>doświadczonych Web Developerów</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: true,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Możliwość personalizacji szablonu w obrębie wyglądu sklepu, wybranych stref, integracji i funkcjonalności</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: false,
                        INDIVIDUAL: true,
                    },
                },
                {
                    name: '<b>Możliwość zbudowania indywiduanych rozwiązań funkcjonalnych, niestandardowych integracji, unikalnych aplikacji</b>',
                    values: {
                        BASIC: false,
                        GO: false,
                        GO_PLUS: false,
                        INDIVIDUAL: true,
                    },
                },
            ],
        },
    ];

    return (
        <Box {...props}>
            <TableSectionWithNav
                title="Poznaj nasze pakiety wdrożeniowe"
                valuesName={valuesName}
                mainCategories={mainCategories}
                tableSection={tableSection}
                tableColumns={4}
                isOpenAll={true}
                isBlocked={false}
                headerValues={headerValues}
                valuesNameMobile={valuesNameMobile}
            />
        </Box>
    );
};
